<template>
    <div class="con-exemple-prompt mb-6 scrollBug">
        <table class="w-full">
            <thead>
                <tr>
                    <th>Question*</th>
                    <th></th>
                    <th>Type*</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(resource, i) in resources">
                    <td style="min-width: 350px">
                        <vs-input
                            v-model="resource.title"
                            size="large"
                            name="title"
                            class="w-full"
                        />
                    </td>
                    <td>
                    
                    </td>
                    <td style="width: 250px">
                        <Multiselect
                            v-model="resource.type"
                            :options="types.data.map(t => ({id: t, title: t}))"
                            track-by="id"
                            label="title"
                            :multiple="false"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                            :loading="types.loading"
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </td>
                    <td class="flex items-center justify-end gap-3" style="width: 88px; height: 43px">
                        <vs-button 
                            v-if="resource.edit" 
                            color="primary" 
                            type="border"
                            radius 
                            @click="addNewLine" 
                            :disabled="!canAddNewLine(resource)"
                        >
                            <i class="fa fa-plus mx-1"></i>
                        </vs-button>

                        <vs-button 
                            color="primary" 
                            type="border" 
                            class="px-5 py-3"
                            :disabled="!canRemoveLine()" 
                            @click="removeLine(i)"
                        >
                            <i class="fa fa-trash"></i>
                        </vs-button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="flex justify-center mt-10 gap-3">
            <vs-radio v-model="questionOnly" vs-name="question_only" vs-value="1">
                Ne créer que les questions
            </vs-radio>

            <vs-radio v-model="questionOnly" vs-name="question_only" vs-value="0">
                Créer un bloc associé
            </vs-radio>
        </div>
    </div>
</template>

<script>

import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect
    },
    props: {
        value: {
            type: Object
        },
    },
    data() {
        return {
            resources: [],
            types: {
                data: [],
                loading: false
            },
            questionOnly: '1'
        }
    },
    created() {
        this.loadTypes();
        this.addNewLine();
    },
    watch: {
        hasError(value) {
            this.$emit("error", value);
        },
        resources: {
            handler() {
                this.emitInput();
            },
            deep: true
        },
        questionOnly(value) {
            this.emitInput();
        }
    },
    computed: {

        hasError() {

            let error = false;

            this.resources.forEach(r => {
                if (!r.title || !r.type) {
                    error = true
                }
            })

            return error;
        },
    },
    methods: {
        emitInput() {
            this.$emit("input", {
                questions: [...this.resources],
                questionOnly: this.questionOnly == '1' ? true : false
            });
        },
        addNewLine() {
            this.resources.forEach(r => {
                r.edit = false;
            })

            const defaultType = this.resources.length  ? this.resources[this.resources.length -1].type : null

            this.resources.push({
                title: null,
                type: defaultType,
                edit: true
            });
        },
        canAddNewLine(resource) {
            return !!resource.title && !!resource.type;
        },
        canRemoveLine() {
            return this.resources.length > 1;
        },
        removeLine(lineNumber) {
            this.resources = this.resources.filter((r, i) => i != lineNumber)
        },
        async loadTypes() {
            this.types.loading = true;
            window
                .axios({
                    method: "get",
                    url: "/api/referentiel/questions/types"
                })
                .then(response => {
                    this.types.data = response.data;
                    this.types.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

    }
}

</script>